import { useSelector } from "react-redux";
import AuthRepository from "src/repository/AuthRepository";
import CartRepository from "src/repository/CartRepository";
import Auth from "src/service/Auth";
import { getCustomerScopeInformation } from "src/store/slice/auth";
import store from "src/storeWire";

export function useAuthStore() {
    const SHIPPING_ADDRESS_LIST = useSelector((state) => state.entities.auth.SHIPPING_ADDRESS_LIST);
    const CUSTOMER_INFORMATION = useSelector((state) => state.entities.auth.CUSTOMER_INFORMATION);

    let data = {
        SHIPPING_ADDRESS_LIST,
        CUSTOMER_INFORMATION
    };
    let fetch = {
        shipping_address_list: async () => {
            return await new AuthRepository().setShippingAddressList();
        },
        get_customer_scope_information: async () => {
            return await store.dispatch(getCustomerScopeInformation())
        },
        get_user_verification: async (token) => {
            return await new Auth().getUserVerification(token)
        }

    };
    let set = {
        default_shipping_address_id: async (defaultAddressId) => {
            return await new Auth().setDefaultShippingAddress(defaultAddressId)
        },
        shipping_address_id: async (shipToAddressId) => {
            return await new CartRepository().setShippingAddressID(shipToAddressId)
        }
    };
    return [data, fetch, set]
}